var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 20,
    viewBox: "0 0 69 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2868 18.6035L67.8348 9.89348L63.3122 0.882812L58.2868 18.6035Z",
    fill: "#097939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0708 18.6035L64.6188 9.89348L60.0962 0.882812L55.0708 18.6035Z",
    fill: "#ED752E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4415 0.977643L5.4215 15.2943L19.6928 15.3943L23.6128 0.977643H27.2308L22.5308 17.7376C22.3508 18.3776 21.6655 18.8976 21.0008 18.8976H2.70817C1.59883 18.8976 0.941499 18.031 1.2415 16.9643L5.72417 0.977643H9.4415ZM53.5628 0.877643H57.1808L52.1555 18.8976H48.4355L53.5628 0.877643ZM27.6335 8.38564L45.7242 8.28564L46.9308 4.48098H28.5375L29.6428 0.976976L49.2428 0.796976C50.4628 0.785643 51.1895 1.73031 50.8682 2.90831L49.0215 9.65764C48.6995 10.835 47.4482 11.789 46.2282 11.789H30.0455L28.1375 19.1976H24.6175L27.6335 8.38564Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpi);
export default __webpack_public_path__ + "static/media/upi.ae8be14b3eaa56b6219da35ee8e54475.svg";
export { ForwardRef as ReactComponent };